import React from 'react';
import { restrictToAlphabetic, OnlyNumeric } from './InputValidations';

export const LeadSubmitDetails = (props) => {

    const { handleLeadbuyerInfo, leadBuyerInfo, handleLeadSubmit, handleModalVisible } = props;

    return (
        <>
            <div className='backdrop' onClick={handleModalVisible}>

            </div>
            <div className="modal show leadGenerationModel" role="dialog" style={{ display: 'block' }}>
                <div className="modal-dialog">
                    <div className="modal-content-center">
                        <button type="button" className="close" onClick={handleModalVisible}>
                            <img src="/Images/X.png" width="24" height="24" alt='' />
                        </button>
                        <div className="congrats-container congratsModalN">
                            Let us assist you in ordering more vouchers. <br />
                            Please provide the following, and a team member will contact you shortly.
                        </div>
                        <div className="mx-auto callBackContainer">
                            <div className="mb-2 text-left">
                                <label htmlFor="BuyerName" className="form-label">Your Name*</label>
                                <input type="text" onInput={restrictToAlphabetic} value={leadBuyerInfo.BuyerName} onChange={(e) => { handleLeadbuyerInfo("BuyerName", e) }} autoComplete="off" name="BuyerName" className="form-control-krle" id="buyerName" placeholder="Please enter your name" maxLength="80" />
                            </div>
                            <div className="mb-2 text-left">
                                <label htmlFor="BMobileNo" className="form-label">Mobile number*</label>
                                <input type="text" onInput={OnlyNumeric} value={leadBuyerInfo.MobileNo} onChange={(e) => { handleLeadbuyerInfo("MobileNo", e) }} autoComplete="off" name="BMobileNo" className="form-control-krle" id="bMobileNo" placeholder="10 digit mobile no." maxLength="10" />
                            </div>
                            <div className="w-100 mt-4">
                                <button className="summary-btn w-100" onClick={handleLeadSubmit}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}